var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledHome = function SvgFilledHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D3C",
    d: "M14.997 4.262c-1.783-1.426-2.675-2.14-3.664-2.414a5 5 0 0 0-2.666 0c-.99.274-1.881.988-3.665 2.414l-.958.767c-1.103.882-1.654 1.323-2.05 1.87a5 5 0 0 0-.773 1.607c-.18.652-.18 1.358-.18 2.77v4.441a4.306 4.306 0 0 0 4.306 4.306A2.153 2.153 0 0 0 7.5 17.87v-3.472a2.5 2.5 0 0 1 5 0v3.472c0 1.19.964 2.153 2.153 2.153a4.306 4.306 0 0 0 4.305-4.306v-4.441c0-1.412 0-2.118-.18-2.77a5 5 0 0 0-.772-1.606c-.396-.548-.948-.989-2.05-1.87z"
  })));
};
export default SvgFilledHome;